import { createApp } from 'vue'
import pinia from '@/helpers/pinia'
import wishlist from '@/components/wishlist.vue'

createApp(wishlist).use(pinia).mount('#wishlist')
